/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    AfterViewInit,
    Component,
    Input,
} from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services/schema-service';
import { IpAddrMatchConfigItem } from 'ajs/modules/match/factories';
import * as l10n from './ip-addr-match-readonly.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to show readonly information for ip-addr-match.
 * @author Akul Aggarwal
 */
@Component({
    selector: 'ip-addr-match-readonly',
    templateUrl: './ip-addr-match-readonly.component.html',
})
export class IpAddrMatchReadonlyComponent implements AfterViewInit {
    @Input()
    public editable: IpAddrMatchConfigItem;

    /**
     * Optional variable. Default value will be clientIpAddressLabel.
     */
    @Input()
    public matchLabel?: string;

    public readonly l10nKeys = l10nKeys;

    constructor(
        private readonly l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngAfterViewInit(): void {
        this.matchLabel = this.l10nService.getMessage(
            this.matchLabel ?? l10nKeys.clientIpAddressLabel,
        );
    }

    /**
     * Combines address and groupNames to return flat list of all user selections.
     */
    public get addressList(): string[] {
        return [...this.editable.addresses, ...this.editable.groupNames];
    }

    /**
     * Convenience method to get text label for selected match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_criteria,
        );
    }

    /**
     * Used in *ngFor.
     */
    public trackByIndex(index: number): number {
        return index;
    }
}
